export const DEFAULT_404_PAGE = '/404';
export const DEFAULT_BUY_PAGE = '/buy';
export const ACCOUNT_PAGE = '/account';
export const ACCOUNT_PROFILE_PAGE = '/account/profile';
export const ACCOUNT_BILLING_PAGE = '/account/[index]';
export const PRINT_NOTES_URL = '/print/notes';
export const HOME_DASHBOARD_URL = '/home/dashboard';
export const LOGIN_URL = '/login';
export const LOGOUT_URL = '/logout';
export const LIBRARY_URL = '/library';
export const PLAYLISTS_URL = '/playlist';
export const EVENTS_URL = '/events';
export const EVENT_URL = '/events/video';
export const PODCAST_URL = '/podcast';

export const REDIRECT_PARAM = 'afterAuthRedirect';

export const SIMPLECAST_PLAYER_URL = 'https://player.simplecast.com';
